export const SET_LOADING = 'SET_LOADING';
export const LOGOUT = 'LOGOUT';
export const SET_USER = 'SET_USER';

// export const GET_COUNTRY = 'GET_COUNTRY';
// export const GET_GOVERNORATE = 'GET_GOVERNORATE';
// export const GET_AREA = 'GET_AREA';
// export const GET_LANGUAGE_LIST = 'GET_LANGUAGE_LIST';
// export const GET_ADDRESS_LIST = 'GET_ADDRESS_LIST';
// export const GET_TERMS = 'GET_TERMS';
// export const GET_ALL_USER = 'GET_ALL_USER';
// export const GET_TAXI_DATA = 'GET_TAXI_DATA';
// export const GET_SPARE_PART_DATA = 'GET_SPARE_PART_DATA';
// export const GET_CAR_DEALER_DATA = 'GET_CAR_DEALER_DATA';
// export const GET_CAR_SALE_DATA = 'GET_CAR_SALE_DATAA';
// export const GET_CAR_RENT_DATA = 'GET_CAR_RENT_DATA';
export const USER_REGISTER = ' USER_REGISTER';
export const OTP_VERIFICATION = ' OTP_VERIFICATION';
export const ADD_GARAGE_DATA = 'ADD_GARAGE_DATA';
export const UPDATE_GARAGE_DATA = 'UPDATE_GARAGE_DATA';
export const GET_GARAGE_SERVICES_DATA = 'GET_GARAGE_SERVICES_DATA';
export const ADD_SPARE_PARTS_DATA = 'ADD_SPARE_PARTS_DATA';
export const ADD_CAR_DELEAR_DATA = 'ADD_CAR_DELEAR_DATA';
export const ADD_CAR_RENT_DATA = 'ADD_CAR_RENT_DATA';
export const ADD_CAR_SALE_DATA = 'ADD_CAR_SALE_DATA';
export const ADD_TAXI_DATA = 'ADD_TAXI_DATA';
export const ADD_MEDIA_DATA = 'ADD_MEDIA_DATA';
export const UPDATE_SPARE_PART_DATA = 'UPDATE_SPARE_PART_DATA';
export const UPDATE_CAR_DEALER_DATA = 'UPDATE_CAR_DEALER_DATA';
export const UPDATE_CAR_RENT_DATA = 'UPDATE_CAR_RENT_DATA';
export const UPDATE_TAXI_DATA = 'UPDATE_TAXI_DATA';
export const GET_CAR_AGENT_LISTING = 'GET_CAR_AGENT_LISTING';

export const GET_GARAGE_FILTER_DATA = 'GET_GARAGE_FILTER_DATA';
export const FORGOT_PASSWORD = ' FORGOT_PASSWORD';
export const GET_ONE_GARAGE_LIST = 'GET_ONE_GARAGE_LIST';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const GET_GARAGE_CATEGORY = 'GET_GARAGE_CATEGORY';
export const FILTER_GARAGE_LIST_WITH_CATEGORY =
  'FILTER_GARAGE_LIST_WITH_CATEGORY';

export const GET_GARAGE_CARBRAND = 'GET_GARAGE_CARBRAND';
export const GET_TAXI_OWNER_DATA = 'GET_TAXI_OWNER_DATA';

export const GET_CAR_MODEL = 'GET_CAR_MODEL';
export const GET_CAR_MODELS = 'GET_CAR_MODELS';
export const GET_CAR_SAFETY = 'GET_CAR_SAFETY';
export const GET_CAR_COMFORT = 'GET_CAR_COMFORT';
export const GET_CAR_CYLINDER = 'GET_CAR_CYLINDER';
export const GET_CAR_FUEL_TYPE = 'GET_CAR_FUEL_TYPE';
export const GET_CAR_MODEL_YEAR = 'GET_CAR_MODEL_YEAR';
export const GET_CAR_SEATS = 'GET_CAR_SEATS';
export const GET_CAR_DOORS = 'GET_CAR_DOORS';
export const GET_CAR_COLORS = 'GET_CAR_COLORS';

export const GET_SPARE_PART_CATEGORY = 'GET_SPARE_PART_CATEGORY';
export const GET_CAR_DEALER_CAR_LISTING = 'GET_CAR_DEALER_CAR_LISTING';
export const GET_SPARE_PART_LISTING = 'GET_SPARE_PART_LISTING';
export const GET_CAR_DEALER_LISTING = 'GET_CAR_DEALER_LISTING';
export const GET_FILTERED_CAR_DEALER_LISTING =
  'GET_FILTERED_CAR_DEALER_LISTING';
export const GET_ONE_CARDEALER_LIST = 'GET_ONE_CARDEALER_LIST';
export const GET_ONE_PART_LIST = 'GET_ONE_PART_LIST';
export const GET_ONE_PART_DETAIL_LIST = 'GET_ONE_PART_DETAIL_LIST';
export const GET_CAR_WAHS_CATEGORY = 'GET_CAR_WAHS_CATEGORY';
export const GET_CAR_WASH_LISTING = 'GET_CAR_WASH_LISTING';
export const GET_CAR_INSURANCE_CATEGORY = 'GET_CAR_INSURANCE_CATEGORY';
export const GET_CAR_INSURANCE_LISTING = 'GET_CAR_INSURANCE_LISTING';
export const GET_CAR_WASH_DETAIL_LIST = 'GET_CAR_WASH_DETAIL_LIST';
export const GET_CAR_INSURANCE_DETAIL_LIST = 'GET_CAR_INSURANCE_DETAIL_LIST';
export const GET_TAXI_OWNER_ALL_DATA = 'GET_TAXI_OWNER_ALL_DATA';
export const GET_TAXI_OWNER_DETAIL_LIST = 'GET_TAXI_OWNER_DETAIL_LIST';
export const GET_CATEGORY = 'GET_CATEGORY';
export const GET_DRIVING_SCHHOL_WITH_FILTER = 'GET_DRIVING_SCHHOL_WITH_FILTER';
export const GET_DRIVING_SCHOOL_LISTING = 'GET_DRIVING_SCHOOL_LISTING';
export const GET_CAR_PROTECTION_LISTING = 'GET_CAR_PROTECTION_LISTING';
export const GET_CAR_PROTECTION_DETAIL_LIST = 'GET_CAR_PROTECTION_DETAIL_LIST';
export const GET_AIR_CONDITIONING_LISTING = 'GET_AIR_CONDITIONING_LISTING';
export const GET_FILTERED_AIR_CONDITIONING_LISTING =
  'GET_FILTERED_AIR_CONDITIONING_LISTING';
export const DETAIL_LIST = 'DETAIL_LIST';
export const GET_QUICKSERVICES_LISTING = 'GET_QUICKSERVICES_LISTING';
export const GET_CAR_AGENTS_LIST = 'GET_CAR_AGENTS_LIST';
export const GET_CAR_AGENTS_DETAIL_LIST = 'GET_CAR_AGENTS_DETAIL_LIST';
export const GET_cAR_RENT_LISTING = 'GET_cAR_RENT_LISTING';
export const GET_cAR_RENT_CAR_LISTING = 'GET_cAR_RENT_CAR_LISTING';
export const GET_MY_BUSINESS = 'GET_MY_BUSINESS';
export const GET_SPARE_PARTS = 'GET_SPARE_PARTS';
export const GET_TOWING_OWNER_ALL_DATA = 'GET_TOWING_OWNER_ALL_DATA';
export const GET_SINGLE_CAR_TOWRING_DATA = 'GET_SINGLE_CAR_TOWRING_DATA';
export const GET_ALL_PLANS = 'GET_ALL_PLANS';
export const MAKE_NEW_PAYMENT = 'MAKE_NEW_PAYMENT';
export const GET_ALL_PACKAGES_HISTORY = 'GET_ALL_PACKAGES_HISTORY';
export const GET_CURRENT_PLAN = 'GET_CURRENT_PLAN';

export const GET_CAR_SALE_DATA = 'GET_CAR_SALE_DATA';

export const GET_SAVED_ITEMS_LIST = 'GET_SAVED_ITEMS_LIST';
export const GET_RECENT_VIEWED_CARS_LIST = 'GET_RECENT_VIEWED_CARS_LIST';

// UPDATE USER PROFILE
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';
export const GETTING_USER_PROFILE = 'GETTING_USER_PROFILE';
export const GETTING_USER_CAR_DETAILS = 'GETTING_USER_CAR_DETAILS';
export const GETTING_USER_MY_POST = 'GETTING_USER_MY_POST';
export const USER_GARAGE_AZ_FILTER = 'USER_GARAGE_AZ_FILTER';
export const USER_GARAGE_ZA_FILTER = 'USER_GARAGE_ZA_FILTER';
export const USER_SPARE_PARTS_AZ_FILTER = 'USER_SPARE_PARTS_AZ_FILTER';
export const USER_SPARE_PARTS_ZA_FILTER = 'USER_SPARE_PARTS_ZA_FILTER';
export const FILTER_SPARE_PARTS_WITH_CATEGORY =
  'FILTER_SPARE_PARTS_WITH_CATEGORY';
